var ccbn = {
  "exhibitionId": "91904571a1934d278206f029dc12a1e0",
  // "projectId": "c3e7c8a8133c470f9b7c1a26e6a89018", 测试地址
  projectId: "c7b8fb8338964574894f9bcb5020696f",
  "AppId": "",
}

export default ccbn;